






































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CrsForm } from '@/plugins/crs-form';
import { IProductProperty } from '@resclick/data-access';
import { i18n } from '@/i18n';

@Component
export default class GuestInfo extends Vue {
  @Prop() form!: CrsForm<'orders', 'create'>;
  @Prop() guestsType!: 'adults' | 'children';
  @Prop() guests!: IProductProperty['adults' | 'children'];
  @Prop() flights!: number;
  @Prop() productIndex!: number;

  get genderOptions() {
    return [
      { label: i18n.t('GENERAL.MALE'), value: 'MALE' },
      { label: i18n.t('GENERAL.FEMALE'), value: 'FEMALE' },
    ];
  }
}
